import React, { useState } from 'react';
import styles from './Css/UserSeries.module.css';
import { useAuthorEbooks } from '../../../hooks/useAuthors';
import { useNavigate } from 'react-router-dom';
import Loading from '../../../common/HousGlass Loader/Loading';

function UserSeries({id}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [imagesPerPage] = useState(6);
  const navigate = useNavigate();
  
  const {
    ebooks,
    isLoading,
    error,
  } = useAuthorEbooks(id);
  
  // Handle book click with conditional navigation
  const handleBookClick = (book) => {
    if (book.series_id) {
      // If the book has a series, navigate to series page
      navigate(`/book-details/${book.slug}`);
    } else {
      // If no series, navigate directly to book detail page
      navigate(`/book-detail/${book.slug}`);
    }
  };
  
  // Loading state
  if (isLoading) {
    return <div className={styles.loading}><Loading/></div>;
  }
  
  // Error state
  if (error) {
    return <div className={styles.error}>Error loading books: {error.message}</div>;
  }
  
  // Check if there are no books
  if (!ebooks || ebooks.length === 0) {
    return null;
  }
  
  // Get current books
  const indexOfLastBook = currentPage * imagesPerPage;
  const indexOfFirstBook = indexOfLastBook - imagesPerPage;
  const currentBooks = ebooks.slice(indexOfFirstBook, indexOfLastBook);
  
  // Calculate total pages
  const totalPages = Math.ceil(ebooks.length / imagesPerPage);
  
  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  // Go to previous page
  const goToPrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };
  
  // Go to next page
  const goToNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };
  
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Author's Books</h2>
      
      <div className={styles.imageGrid}>
        {currentBooks.map(book => (
          <div 
            key={book.id} 
            className={styles.imageCard}
            onClick={() => handleBookClick(book)}
          >
            <img
              src={book.cover_image_url_for_computer || '/images/default-book-cover.png'}
              alt={book.title}
              className={styles.image}
            />
          </div>
        ))}
      </div>
      
      {totalPages > 1 && (
        <>
          <div className={styles.pagination}>
            <button
              onClick={goToPrevPage}
              disabled={currentPage === 1}
              className={styles.pageButton}
            >
              Previous
            </button>
            
            <div className={styles.pageNumbers}>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => paginate(i + 1)}
                  className={`${styles.pageNumberButton} ${currentPage === i + 1 ? styles.active : ''}`}
                >
                  {i + 1}
                </button>
              ))}
            </div>
            
            <button
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
              className={styles.pageButton}
            >
              Next
            </button>
          </div>
          
          <div className={styles.pageInfo}>
            Page {currentPage} of {totalPages}
          </div>
        </>
      )}
    </div>
  );
}

export default UserSeries;